import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Navigation, Footer } from "@/components/sections";

export const DatenschutzPage = () => {
  const { t } = useTranslation();
  const rightsList = t('legal.privacy.rightsList', { returnObjects: true });
  
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Datenschutzerklärung - ForestHub</title>
        <meta name="description" content="Datenschutzerklärung von ForestHub - DSGVO-konform" />
      </Helmet>
      
      <Navigation onRequestDemo={() => {}} />
      
      <div className="pt-28 pb-24 max-w-3xl mx-auto px-6">
        <h1 
          className="text-3xl font-semibold text-stone-900 mb-8" 
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('legal.privacy.title')}
        </h1>
        
        <div className="prose prose-stone max-w-none">
          <p className="lead">{t('legal.privacy.intro')}</p>
          
          <h2>{t('legal.privacy.responsible')}</h2>
          <p>{t('legal.privacy.responsibleText')}</p>
          <p>
            <strong>Hodema edertools AB</strong><br />
            Kyrkvägen 66<br />
            88372 Backe, Sweden<br />
            E-Mail: <a href="mailto:info@hodema.se">info@hodema.se</a>
          </p>
          
          <h2>{t('legal.privacy.collection')}</h2>
          <h3>{t('legal.privacy.collectionTitle')}</h3>
          <p>{t('legal.privacy.collectionText')}</p>
          
          <h2>{t('legal.privacy.analytics')}</h2>
          <h3>{t('legal.privacy.analyticsTitle')}</h3>
          <p>{t('legal.privacy.analyticsText')}</p>
          
          <h2>{t('legal.privacy.cookies')}</h2>
          <p>{t('legal.privacy.cookiesText')}</p>
          
          <h2>{t('legal.privacy.rights')}</h2>
          <p>{t('legal.privacy.rightsText')}</p>
          <ul>
            {rightsList.map((right, index) => (
              <li key={index}>{right}</li>
            ))}
          </ul>
          
          <h2>{t('legal.privacy.complaint')}</h2>
          <p>{t('legal.privacy.complaintText')}</p>
          
          <h2>{t('legal.privacy.changes')}</h2>
          <p>{t('legal.privacy.changesText')}</p>
          
          <h2>{t('legal.privacy.contact')}</h2>
          <p>{t('legal.privacy.contactText')} <a href="mailto:info@hodema.se">info@hodema.se</a></p>
        </div>
        
        <div className="mt-12">
          <a href="/" className="text-[#1B4D3E] font-medium hover:underline">
            ← {t('legal.privacy.back')}
          </a>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};
